import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Col, Form, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap'
import Api from '../../../Global/Modules/Api'

const FETCH_URL = "/api/groups"
class GroepenEdit extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            Name: "",
            id: 0,
            //groupAbbreviation: ""
        }
    }
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ [name]: value })
    }
    handleSubmit(event) {
        event.preventDefault()

        // TODO: Post this.state to the API
        Api.PostApi(FETCH_URL, this.state, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    this.setState({ errors: response });
                } else {
                    alert("Groep updated")
                    window.location.href = "/admin/leden/groepen"
                }

            })

    }
    componentWillMount() {
        Api.GetApi("api/groups/" + this.props.id).then(data => {
            this.setState({ Name: data.name })
            this.setState({ Id: data.id })
        });
    }
    render() {

        return (
            <div>
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="GroepToevoegenNaam">
                        <Col componentClass={ControlLabel} sm={4}>
                            Groep naam
                        </Col>
                        <Col sm={6}>
                            <FormControl type="text" name="Name" value={this.state.Name} onChange={this.handleChange} />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col sm={12}>
                            <LinkContainer to="/admin/leden/groepen"><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                            <Button type="submit" className="pull-right">Opslaan</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default GroepenEdit;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Groepen/Edit.js